import { router } from 'expo-router';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { StyleSheet } from 'react-native';

import { IconClose, Text, tokens } from '@fhs/ui';

interface Props {
  title: string;
  onClose?: () => void;
  style?: StyleProp<ViewStyle>;
}

export function ActionSheetScreenHeader({ title, onClose, style }: Props) {
  return (
    <View style={[styles.container, style]}>
      <Text.Ui size="md" weight="semibold">
        {title}
      </Text.Ui>
      <TouchableOpacity style={styles.closeIcon} onPress={onClose ?? router.back}>
        <IconClose size={24} />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 18,
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderColor: tokens.colors.$black10,
  },
  closeIcon: {
    position: 'absolute',
    right: 16,
  },
});
